<template>
    <div class="overflow-x-hidden relative">
        <section
            class="our-story-section text-center grid flex flex-wrap justify-content-center align-items-center md:px-4 md:px-6 relative">
            <div class="container px-4 md:px-6 pt-8 md:py-2">
                <div class="grid ">
                    <div class="col-12 lg:col-6 align-self-end flex justify-content-center">
                        <div class="story-visual">
                            <img :src="bgUrl" alt="Our Story - Learning Journey"
                                class="w-full " />
                        </div>
                    </div>

                    <div class="col-12 lg:col-6 pb-6">
                        <div class="story-content">
                            <h1 class="LandingPage-Title orange-text text-left mb-3">Our Story</h1>
                            <h1 class="LandingPage-Title text-left mb-4">
                                Your Path to Better Learning Starts Here
                            </h1>

                            <div class="story-text text-left md:col-9 ">
                                <p class="Label leading-relaxed mb-4">
                                    In Sri Lanka, education is more than a goal. It's a journey that shapes who we are.
                                    Yet for many students, finding the right guidance isn't always easy. And for
                                    passionate tutors, reaching the learners who truly need them can be just as
                                    challenging.
                                </p>

                                <p class="Label leading-relaxed mb-4">
                                    Ilearn'd Tutors was created to bridge that gap, a platform built to make learning
                                    simple, personal, and accessible to everyone. We connect students with verified,
                                    trusted tutors who can inspire confidence, curiosity, and growth.
                                </p>

                                <p class="Label leading-relaxed mb-0">
                                    This is more than technology, it's a movement to make learning meaningful. Because
                                    when knowledge is shared, everyone grows.
                                </p>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
import { usePublicUrl } from "@/utils/getPublicUrl"

const bgUrl = usePublicUrl("public/Group 113.png");
</script>
<style scoped>
.orange-text{
    color: #FE8E20;
    font-size: 56px !important;
}
.story-visual{
    height: 400px;
    width: 418px;
}
</style>